// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/account_management/users/firstparty/v2/update_user.proto

/* eslint-disable */
import { ApiGender, apiGenderFromJSON, apiGenderToJSON, ApiUser } from "./user";

/** Request message for UpdateUser (PATCH /v2/users/me). */
export interface ApiUpdateUserRequest {
  /** Locale preference of the user. */
  readonly locale?:
    | string
    | null
    | undefined;
  /** Timezone of the user. */
  readonly timezone?:
    | string
    | null
    | undefined;
  /** Whether the user has completed onboarding. */
  readonly onboarded?:
    | boolean
    | null
    | undefined;
  /** Gender of the user. */
  readonly gender?:
    | ApiGender
    | null
    | undefined;
  /** Birth date of the user (YYYY-MM-DD format). */
  readonly birthdate?:
    | string
    | null
    | undefined;
  /** Birth city of the user. */
  readonly birthCity?:
    | string
    | null
    | undefined;
  /** Birth zipcode of the user. */
  readonly birthZipcode?:
    | string
    | null
    | undefined;
  /** Birth country of the user. */
  readonly birthCountry?:
    | string
    | null
    | undefined;
  /** Avatar upload parameters. */
  readonly avatar?: ApiUpdateUserRequestAvatarParams | null | undefined;
}

/** Avatar upload parameters. */
export interface ApiUpdateUserRequestAvatarParams {
  /** Raw file data. */
  readonly file?:
    | Uint8Array
    | null
    | undefined;
  /** Original file name. */
  readonly fileName?:
    | string
    | null
    | undefined;
  /** MIME type of the file (e.g. "image/jpeg"). */
  readonly fileContentType?:
    | string
    | null
    | undefined;
  /** URL of the file when hosted remotely. */
  readonly fileUrl?: string | null | undefined;
}

/** Response message for UpdateUser. */
export interface ApiUpdateUserResponse {
  /** The updated user data. */
  readonly user: ApiUser | null;
}

export const ApiUpdateUserRequest: MessageFns<ApiUpdateUserRequest> = {
  fromJSON(object: any): ApiUpdateUserRequest {
    return {
      locale: isSet(object.locale) ? globalThis.String(object.locale) : null,
      timezone: isSet(object.timezone) ? globalThis.String(object.timezone) : null,
      onboarded: isSet(object.onboarded) ? globalThis.Boolean(object.onboarded) : null,
      gender: isSet(object.gender) ? apiGenderFromJSON(object.gender) : null,
      birthdate: isSet(object.birthdate) ? globalThis.String(object.birthdate) : null,
      birthCity: isSet(object.birth_city) ? globalThis.String(object.birth_city) : null,
      birthZipcode: isSet(object.birth_zipcode) ? globalThis.String(object.birth_zipcode) : null,
      birthCountry: isSet(object.birth_country) ? globalThis.String(object.birth_country) : null,
      avatar: isSet(object.avatar) ? ApiUpdateUserRequestAvatarParams.fromJSON(object.avatar) : null,
    };
  },

  toJSON(message: ApiUpdateUserRequest): unknown {
    const obj: any = {};
    if (message.locale !== undefined && message.locale !== null) {
      obj.locale = message.locale;
    }
    if (message.timezone !== undefined && message.timezone !== null) {
      obj.timezone = message.timezone;
    }
    if (message.onboarded !== undefined && message.onboarded !== null) {
      obj.onboarded = message.onboarded;
    }
    if (message.gender !== undefined && message.gender !== null) {
      obj.gender = apiGenderToJSON(message.gender);
    }
    if (message.birthdate !== undefined && message.birthdate !== null) {
      obj.birthdate = message.birthdate;
    }
    if (message.birthCity !== undefined && message.birthCity !== null) {
      obj.birth_city = message.birthCity;
    }
    if (message.birthZipcode !== undefined && message.birthZipcode !== null) {
      obj.birth_zipcode = message.birthZipcode;
    }
    if (message.birthCountry !== undefined && message.birthCountry !== null) {
      obj.birth_country = message.birthCountry;
    }
    if (message.avatar !== undefined && message.avatar !== null) {
      obj.avatar = ApiUpdateUserRequestAvatarParams.toJSON(message.avatar);
    }
    return obj;
  },
};

export const ApiUpdateUserRequestAvatarParams: MessageFns<ApiUpdateUserRequestAvatarParams> = {
  fromJSON(object: any): ApiUpdateUserRequestAvatarParams {
    return {
      file: isSet(object.file) ? bytesFromBase64(object.file) : null,
      fileName: isSet(object.file_name) ? globalThis.String(object.file_name) : null,
      fileContentType: isSet(object.file_content_type) ? globalThis.String(object.file_content_type) : null,
      fileUrl: isSet(object.file_url) ? globalThis.String(object.file_url) : null,
    };
  },

  toJSON(message: ApiUpdateUserRequestAvatarParams): unknown {
    const obj: any = {};
    if (message.file !== undefined && message.file !== null) {
      obj.file = base64FromBytes(message.file);
    }
    if (message.fileName !== undefined && message.fileName !== null) {
      obj.file_name = message.fileName;
    }
    if (message.fileContentType !== undefined && message.fileContentType !== null) {
      obj.file_content_type = message.fileContentType;
    }
    if (message.fileUrl !== undefined && message.fileUrl !== null) {
      obj.file_url = message.fileUrl;
    }
    return obj;
  },
};

export const ApiUpdateUserResponse: MessageFns<ApiUpdateUserResponse> = {
  fromJSON(object: any): ApiUpdateUserResponse {
    return { user: isSet(object.user) ? ApiUser.fromJSON(object.user) : null };
  },

  toJSON(message: ApiUpdateUserResponse): unknown {
    const obj: any = {};
    if (message.user !== undefined && message.user !== null) {
      obj.user = ApiUser.toJSON(message.user);
    }
    return obj;
  },
};

function bytesFromBase64(b64: string): Uint8Array {
  if ((globalThis as any).Buffer) {
    return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
  } else {
    const bin = globalThis.atob(b64);
    const arr = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; ++i) {
      arr[i] = bin.charCodeAt(i);
    }
    return arr;
  }
}

function base64FromBytes(arr: Uint8Array): string {
  if ((globalThis as any).Buffer) {
    return globalThis.Buffer.from(arr).toString("base64");
  } else {
    const bin: string[] = [];
    arr.forEach((byte) => {
      bin.push(globalThis.String.fromCharCode(byte));
    });
    return globalThis.btoa(bin.join(""));
  }
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
